// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3V6N9","filesListContainer":"PosDisputesFiles_filesListContainer__3lf82","filesButton":"PosDisputesFiles_filesButton__3TbAE"};